// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2VoGD","resendInfoText":"OnGoingPaymentBox_resendInfoText__2QP7f"};